import _get from 'lodash/get';

import { INPUT_ID } from '../stubs';

export default function getFormInputData(type = '', metadata = {}) {
  switch (type) {
    case INPUT_ID.EMAIL: {
      return {
        id: INPUT_ID.EMAIL,
        label: 'E-mail Address',
        type: 'email',
        placeholder: 'Your e-mail address',
        toggleInfo: {
          to: INPUT_ID.PHONE,
          text: 'Use phone number'
        }
      };
    }
    case INPUT_ID.PHONE: {
      return {
        id: INPUT_ID.PHONE,
        label: 'Phone Number',
        type: 'tel',
        placeholder: 'Your phone number',
        toggleInfo: {
          to: INPUT_ID.EMAIL,
          text: 'Use E-mail address'
        }
      };
    }
    case INPUT_ID.ORDER: {
      const regex = _get(metadata, 'nameRegEx', null);
      // const example = _get(metadata, 'example', null);
      // const helpText = _get(metadata, 'helpText', null);
      return {
        id: INPUT_ID.ORDER,
        label: 'Order Number',
        type: 'text',
        placeholder: regex
          ? `Order Number e.g. ${regex}1234`
          : 'Your order number',
        suggestionData: {
          regex: regex ? `^${regex}` : '',
          helpText: `Order Number generally starts with ${regex}`
        },
        toggleInfo: {
          to: INPUT_ID.ZIP,
          text: 'Use Zip/Postal code'
        }
      };
    }
    case INPUT_ID.ZIP: {
      return {
        id: INPUT_ID.ZIP,
        label: 'Shipping Zipcode',
        type: 'text',
        placeholder: 'Zip/Postal code of your last order',
        toggleInfo: {
          to: INPUT_ID.ORDER,
          text: 'Use Order Number'
        }
      };
    }
    case INPUT_ID.GIFT_ZIP: {
      return {
        id: INPUT_ID.GIFT_ZIP,
        label: 'Shipping Zipcode',
        type: 'text',
        placeholder: 'Zip/Postal code of your gifted order',
        toggleInfo: {}
      };
    }
    case INPUT_ID.FIRST_NAME: {
      return {
        id: INPUT_ID.FIRST_NAME,
        label: 'First Name',
        type: 'text',
        placeholder: 'Your first name',
        toggleInfo: {}
      };
    }
    case INPUT_ID.LAST_NAME: {
      return {
        id: INPUT_ID.LAST_NAME,
        label: 'Last Name',
        type: 'text',
        placeholder: 'Your last name',
        toggleInfo: {}
      };
    }
    default:
      return null;
  }
}
